class DataGridEntityConfigFactory {
  getRow(p) {
    return p.row;
  }
  getChipValue(value, type) {
    return {
      value,
      type
    };
  }
  getRowsCount(p) {
    return p.api.getRowsCount();
  }
}
const gridMaxSize = 100;
export {
  DataGridEntityConfigFactory,
  gridMaxSize
};
//# sourceMappingURL=types.js.map
